// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__SLvYm","summary":"CartItem_summary__3eAgU","price":"CartItem_price__-x-cy","amount":"CartItem_amount__tR3IZ","actions":"CartItem_actions__ZZJmS"};